import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import boatrbologo from './images/boat-sm.png';
import downloadFromAppStore from './images/appStoreDownload.svg';
import downloadFromPlayStore from './images/playstoreDownload.svg';
import facebookIcon from './images/facebook.svg';
import instagramIcon from './images/instagram.svg';
import twitterIcon from './images/x-twitter-logo.webp';
import linkedInIcon from './images/linkedin.svg';

import './footer.css';

const Footer = () => {
  const currentUser = useSelector((state) => state.currentUser);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
  return (
    <div className="footer-container">
      <div className="footer-container-align">
        <div className="footer-content">
          {/* <div className="footer-content-boatrbo-icon">
            <img
              src={boatrbologo}
              alt="boat logo"
              style={{
                float: 'left',
                cursor: 'pointer',
                marginBottom: '20px',
                marginTop: '-20px'
              }}
            />
          </div> */}
          <div className="animation-container">
            <svg viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg" className="sailboat-svg">
              {/* <!-- Water paths --> */}
              <path id="water-back" d="M0,45 Q25,40 50,45 T100,45" fill="#5E99C6" />
              <path id="water-front" d="M0,45 Q25,40 50,45 T100,45" fill="#4B81A7" />
                    
              {/* <!-- Sailboat group --> */}
              <g id="boat" transform="translate(10, 0)">
                {/* <!-- Mast --> */}
                <path d="M50,15 L50,30" stroke="#8B4513" strokeWidth="1.5" strokeLinecap="round" />
                {/* <!-- Hull --> */}
                <path d="M35,30 Q45,35 65,30 L35,30 Z" fill="#8B4513" />
                {/* <!-- Sail --> */}
                <path d="M50,15 L60,25 L50,28 Z" fill="#F8F8F8" stroke="#ccc" strokeWidth="0.5" />
              </g>
            </svg>
          </div>
          <div className="footer-content-boatrbo-icon company">
            <div>
              <div to="" className="footer-h4-text-style">
                BoatRBO
              </div>
            </div>
            <div style={{ marginTop: '22px' }}>
              <Link to="/aboutus" className="footer-p-text-style" onClick={scrollToTop}>
                About Us
              </Link>
            </div>
            <div style={{ marginTop: '7px' }}>
              <Link to="/help" className="footer-p-text-style" onClick={scrollToTop}>
                FAQ
              </Link>
            </div>
            <div style={{ marginTop: '7px' }}>
              <Link to="/terms" className="footer-p-text-style" onClick={scrollToTop}>
                Terms
              </Link>
            </div>
            <div style={{ marginTop: '7px' }}>
              <Link to="/privacy" className="footer-p-text-style" onClick={scrollToTop}>
                Privacy
              </Link>
            </div>            
            <div style={{ marginTop: '7px' }}>
              <Link to="/contactus" className="footer-p-text-style" onClick={scrollToTop}>
                Contact
              </Link>
            </div>
          </div>
          <div className="footer-content-boatrbo-icon discover">
            <div>
              <div className="footer-h4-text-style">
                DISCOVER
              </div>
            </div>
            <div style={{ marginTop: '22px' }}>
              <Link to={{ pathname: "/boatresults", state: { findNearMe: true } }} className="footer-p-text-style" onClick={scrollToTop}>
                Boats Near Me
              </Link>
            </div>             
            <div style={{ marginTop: '7px' }}>
              <Link to={{ pathname: "/boatresults", state: { clearSearch: true } }} className="footer-p-text-style" onClick={scrollToTop}>
                Rent A Boat
              </Link>
            </div>
            {currentUser && (
              <div style={{ marginTop: '7px' }}>
                <Link to="/listaboat" className="footer-p-text-style" onClick={scrollToTop}>
                  List A Boat
                </Link>
              </div>
            )}
            <div style={{ marginTop: '7px' }}>
              <Link to="/products" className="footer-p-text-style" onClick={scrollToTop}>
                Marketplace
              </Link>
            </div> 
            <div style={{ marginTop: '7px' }}>
              <Link to="/help" className="footer-p-text-style" onClick={scrollToTop}>
                How It works
              </Link>
            </div>   
            <div style={{ marginTop: '7px' }}>
              <a style={{ color: 'white'}} className="footer-p-text-style" href="https://play.google.com/store/apps/details?id=it.navionics.singleAppMarineLakesHD&hl=en_US" target="_blank" rel="noopener noreferrer">
                Charts & Maps
              </a>
            </div>                                 
          </div>
          <div className="footer-content-boatrbo-icon join-us">
            <div className="footer-h4-text-style">JOIN US ON</div>
            <div
              style={{
                marginTop: '22px',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <a
                href="https://www.facebook.com/BoatRBO1/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img alt="fbicon" src={facebookIcon} />
              </a>
              <a
                href="https://www.instagram.com/boatrboofficial"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img alt="instaicon" src={instagramIcon} />
              </a>
              <a
                href="https://www.x.com"
                target="_blank"
                rel="noopener noreferrer"                
              >
                <img alt="twittericon" src={twitterIcon} style={{ height: '35px', width: '35px' }}/>
              </a>
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img alt="linkdinicon" src={linkedInIcon} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
